<template>
  <br />
  <div id="parallax-world-of-ugg">
    <br />
    <section>
      <div class="img">
        <img class="" src="/AMT2logo_white_bg.png" alt="img" loading="lazy" />
      </div>
      <br />
      <br />
      <div class="page-break"></div>
      <div class="block">
        <div id="circle-shape-example">
          <img
            src="/new meeting pic.jpg"
            alt="pic"
            class="curve"
            loading="lazy"
          />
          <br />
          <p
            class="main-info"
            style="font-size: 20px; line-height: 1.6; color: #333"
          >
            <strong
              >South Africa’s Leading Telephone Call Recording System and
              Quality Management Software. </strong
            >Recording a call using a flexible, intuitive, and affordable call
            logger solution is key to achieving optimal operational efficiency.
            No matter the reason why you need call recording in your business,
            be it for call centre recording, agent recording or other, our
            web-based telephone call recording system and quality management
            software will enhance your operational efficiency - guaranteed.
          </p>

          <p
            class="main-info"
            style="font-size: 20px; line-height: 1.6; color: #333"
          >
            As the next-generation successor to the original Amethyst, one of
            the pioneers in telephone recording technology -
            <strong>Amethyst</strong> has evolved to meet the demands of today’s
            fast-paced, digital workplace. Building on the rock-solid foundation
            of its predecessor, the latest version introduces advanced features
            that empower your business to operate more securely, efficiently,
            and flexibly than ever before.
          </p>

          <p
            class="main-info"
            style="font-size: 20px; line-height: 1.6; color: #333"
          >
            With a strong focus on
            <strong>security, mobility, and scalability,</strong> Amethyst
            supports modern work environments by enabling seamless remote
            access, centralized management, and high-level data protection.
            Whether you're a small business or a large enterprise, Amethyst
            adapts to your needs, helping you maintain compliance, improve
            customer interactions, and gain deeper insight into your
            communications, no matter where or how your teams work.
          </p>
        </div>
        <br />
        <br />
        <br />
        <h5>
          Here’s how Amethyst will help you and your team to work smarter:
        </h5>

        <br />
        <br />
        <div class="D1 section-flex">
          <img
            src="/Amethyst Screenshot 1.png"
            alt="Recording"
            class="section-image"
            loading="lazy"
          />
          <div>
            <h3>Recording <em> ~ Enable flexible, intuitive recording </em></h3>
            <ul>
              <li>Calls captured from anywhere, with any PABX.</li>
              <li>
                Recording multiple remote branches with centralized access and
                storage of recordings.
              </li>
              <li>
                Flexibility in recording method topology (PRI, BRI, Analog, VoIP
                Trunks, plus Analog, Digital & VoIP Extensions).
              </li>
              <li>
                Channels multiple recording method combinations into one single
                system.
              </li>
            </ul>
          </div>
        </div>

        <br />
        <br />
        <br />
        <br />

        <div class="D2 section-flex">
          <div>
            <h3>
              Search & Playback <em> ~ Find and hear your calls in seconds </em>
            </h3>
            <ul>
              <li>
                Quick and efficient retrieval of calls for immediate query
                resolution.
              </li>
              <li>
                Time-scale display timeline with selective playback
                capabilities.
              </li>
              <li>Access via any device to call recordings and reports.</li>
              <li>
                Enhanced search functions including Call Type, Number of Tags
                and Number of AQM Templates completed.
              </li>
              <li>
                Powerful, multi-level search, tagging and in-line note
                capabilities.
              </li>
              <li>
                No 3rd party plugins needed to search and listen to calls.
              </li>
            </ul>
          </div>
          <img
            src="/Amethyst Screenshot 2.png"
            alt="Search and Playback"
            class="section-image"
            loading="lazy"
          />
        </div>

        <br />
        <br />
        <br />
        <br />

        <div class="D3 section-flex">
          <img
            src="/Amethyst Screenshot 3.png"
            alt="Storage"
            class="section-image"
            loading="lazy"
          />
          <div>
            <h3>Storage <em> ~ Protect your greatest data assets </em></h3>
            <ul>
              <li>
                Ensures efficient and secure conversion, storage, and retrieval
                of data across all systems.
              </li>
              <li>
                Provides optional cloud-based backup and storage solutions for
                enhanced data protection and accessibility.
              </li>
              <li>
                Includes automatic purging with dual archiving to maintain
                storage efficiency and compliance.
              </li>
            </ul>
          </div>
        </div>

        <br />
        <br />
        <br />
        <br />

        <div class="D4 section-flex">
          <div>
            <h3>
              Technical Management
              <em> ~ Experience technology that just works </em>
            </h3>
            <ul>
              <li>Hassle-free installation with minimal downtime.</li>
              <li>Comprehensive internet-based supervisor training.</li>
              <li>Amethyst can run on either a physical, or virtual server.</li>
              <li>64-bit application for greater efficiency.</li>
              <li>Secure email connectivity – SMTPS.</li>
              <li>
                Free, comprehensive Software Developer Integration Kit (SDK).
              </li>
              <li>Ongoing free same-version software updates.</li>
              <li>Automated system health checks.</li>
              <li>
                Automated software health-checks and error reporting for
                pro-active software management and resolution.
              </li>
            </ul>
          </div>
          <img
            src="/Amethyst Screenshot 4.png"
            alt="Technical Management"
            class="section-image"
            loading="lazy"
          />
        </div>

        <br />
        <br />
        <br />
        <br />

        <div class="D5 section-flex">
          <img
            src="/Amethyst Screenshot 5.png"
            alt="Team Management"
            class="section-image"
            loading="lazy"
          />
          <div>
            <h3>
              Team Management
              <em> ~ Empower your people for better results </em>
            </h3>
            <ul>
              <li>
                Unlimited, multi-level supervisor access at no additional cost.
              </li>
              <li>
                Individualised supervisor permissions for AQM, audit trails,
                dashboards, diagrams, additional modules,<br />
                recording search, recording playback and more.
              </li>
              <li>
                Infinite groups and supervisor structures with multi-way group
                access for easy team management.
              </li>
              <li>
                Automated group structure diagrams for accurate group,
                supervisor, and agent allocation.
              </li>
              <li>
                Custom AQM Template and Questionnaire setup and easy AQM
                Questionnaire sharing.
              </li>
              <li>Advanced Agent Status Review utilities.</li>
              <li>
                Full audit trails. Access to recordings, administration tasks
                and AQM tasks can be traced.
              </li>
            </ul>
          </div>
        </div>

        <br />
        <br />
        <br />
        <br />

        <div class="D6 section-flex">
          <div>
            <h3>
              Intelligence & Reporting
              <em> ~ Work smarter with better insights </em>
            </h3>
            <ul>
              <li>
                Generate flexible and detailed reports and statistics for all
                call recordings to support performance monitoring and
                compliance.
              </li>
              <li>
                Access reports and analytics by individual user, phone
                extension, or specific telephone number for targeted insights.
              </li>
              <li>
                User-friendly dashboards offer a comprehensive overview with
                fast, intuitive Group Access and Agent Quality Monitoring (AQM).
              </li>
              <li>
                Benefit from advanced analytics tools with the ability to
                schedule and generate reports automatically.
              </li>
              <li>
                Distribute reports quickly and securely through automated email
                delivery with encryption options.
              </li>
              <li>
                Includes an advanced auto-logout feature for supervisors to
                enhance security and session control.
              </li>
              <li>
                Share playback access via a secure link to a specific recording,
                available only for a limited and controlled time period.
              </li>
            </ul>
          </div>
          <img
            src="/Amethyst Screenshot 6.PNG"
            alt="Intelligence and Reporting"
            class="section-image"
          />
        </div>

        <br />
        <br />
        <br />

        <div class="D7 section-flex">
          <img
            src="/Amethyst Screenshot 7.PNG"
            alt="Compliance"
            class="section-image"
          />
          <div>
            <h3>
              Compliance <em> ~ Align to legal and customer expectations </em>
            </h3>
            <ul>
              <li>
                Fully complies with key regulatory standards including POPI,
                FICA, FAIS, SOX, PCI, NCA, and CPA to ensure legal and ethical
                data handling.
              </li>
              <li>
                Automatically detects and masks DTMF tones in recordings to
                maintain POPI compliance and protect sensitive information.
              </li>
              <li>
                Allows for muting of sensitive or non-essential content in
                recordings before they are shared, exported, or emailed
                externally.
              </li>
            </ul>
          </div>
        </div>
        <br />
        <br />
        <br />
        <div class="buttton">
          <div
            class="button"
            @click.prevent="openModal('promotion')"
            data-tooltip="Please Click"
          >
            <div class="button-wrapper">
              <div class="text">Amethyst Brochures</div>
              <span class="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  role="img"
                  width="2em"
                  height="2em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17"
                  ></path>
                </svg>
              </span>
            </div>
          </div>

          <!-- Modal -->
          <div
            v-if="showPromotionModal"
            class="modal-overlay"
            @click.self="closeModal"
          >
            <div class="modal-content">
              <h6>Amethyst Brochures</h6>
              <div
                class="scroll-container"
                ref="scrollContainer"
                @scroll="onScroll('promotion')"
                style="max-height: 60vh"
              >
                <div class="entry-content clearfix">
                  <div class="datatex-row-padding">
                    <ul>
                      <li>
                        Our
                        <a
                          href="/Amethyst Brochure 2023.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                          >Amethyst Brochure</a
                        >
                        highlights the key features of our product in a
                        nutshell.
                      </li>
                      <br />
                      <li>
                        The
                        <a
                          href="/Amethyst AQM Brochure 2024.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                          >Amethyst AQM Brochure</a
                        >
                        contains comprehensive information on Agent Quality
                        Management.
                      </li>
                      <br />
                      <li>
                        Learn more about our post-call survey solution in our
                        <a
                          href="/Jibe Brochure.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                          >Jibe Brochure.</a
                        >
                      </li>
                      <br />
                      <li>
                        Our
                        <a
                          href="/MS Teams Recording _ AMETHYST.PDF"
                          target="_blank"
                          rel="noopener noreferrer"
                          >MS Teams Recording</a
                        >
                        brochure outlines our call recording solution and its
                        integration with Microsoft Teams.
                      </li>
                      <br />
                      <li>
                        Our
                        <a
                          href="/Cloud Archiving on Amethyst2.pdf"
                          target="_blank"
                          rel="noopener noreferrer"
                          >Cloud Archiving Brochure</a
                        >
                        highlights the advantages of storing your backups
                        off-site and in the cloud.
                      </li>
                      <br />
                    </ul>
                  </div>
                </div>
              </div>
              <button class="close-button" @click="closeModal">Close</button>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <div class="page-break1"></div>
        <br />
        <br />
        <br />
        <h4>
          <i class="fas fa-circle" style="color: purple"></i> Thinking of
          upgrading from AMETHYSTLite?
        </h4>
        <br />
        <p style="font-size: 22px; line-height: 1.4; color: #333">
          The only differentiation between Amethyst and AmethystLite is the fact
          that Amethyst comes standard with Agent Quality Management (AQM), and
          AmethystLite excludes the Agent Quality Management system, but can be
          purchased as an additional module.
        </p>
        <br />
        <br />
        <h4 style="text-align: right">
          What is Agent Quality Management (AQM)?
          <i class="fas fa-circle" style="color: purple"></i>
        </h4>
        <br />
        <p
          style="
            font-size: 22px;
            line-height: 1.4;
            color: #333;
            text-align: right;
          "
        >
          AQM provides functionality for creating templates which can be used to
          score individual agents’ performance in their interactions with your
          clients. It also allows for the random selection of recordings to be
          marked for scoring, ensuring compliancy with HR requirements.
        </p>
        <br />
        <br />
        <h4>
          <i class="fas fa-circle" style="color: purple"></i> Amethyst YouTube
          Video Playlist.
        </h4>
        <br />
        <p style="font-size: 22px; color: #333">
          Here is everything you need: a step-by-step
          <a
            href="https://www.youtube.com/playlist?list=PLnwEy2yO4kbsZn2MzqkV2kq9BUfhB6xO_"
            target="_blank"
            rel="noopener noreferrer"
            >Amethyst 2 Instructional Video</a
          >
          playlist from the Datatex YouTube channel.
        </p>
        <br />
        <br />
        <div class="page-break1"></div>
        <br />
        <br />
        <div class="frame">
          <p
            style="
              font-size: 22px;
              font-weight: 500;
              color: #333;
              text-align: center;
            "
          >
            Providing cutting-edge Telephone Call Recording and Quality
            Management Solutions since 2002.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "AmethystView",
  data() {
    return {
      showPromotionModal: false,
      promotionScrollProgress: 0,
    };
  },
  methods: {
    openModal(modalName) {
      this.showPromotionModal = false;
      if (modalName === "promotion") {
        this.showPromotionModal = true;
      }
    },
    closeModal() {
      this.showPromotionModal = false;
    },
    onScroll(modalName) {
      let scrollContainer = null;
      if (modalName === "promotion") {
        scrollContainer = this.$refs.scrollContainer;
        if (scrollContainer) {
          this.promotionScrollProgress =
            (scrollContainer.scrollTop /
              (scrollContainer.scrollHeight - scrollContainer.clientHeight)) *
            100;
        }
      }
    },
  },
};
</script>

<style scoped>
.page-break {
  page-break-before: always;
  border: 1px solid purple;
  width: 80%;
  margin-left: 10%;
  justify-content: center;
}
.page-break1 {
  page-break-before: always;
  border: 1px solid gray;
  width: 100%;
  justify-content: center;
}

a {
  position: relative;
  text-decoration: none;
  color: #2c4a66;
  font-weight: 500;
  transition: color 0.3s ease-in-out;
}

a::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 100%;
  height: 2px;
  background-color: #000;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s ease-in-out;
}

a:hover {
  color: #000;
}

a:hover::after {
  transform: scaleX(1);
}

#circle-shape-example {
  margin: 1rem;
}
#circle-shape-example p {
  line-height: 1.6;
  text-align: justify;
  text-justify: inter-word;
}
#circle-shape-example .curve {
  width: 280px;
  height: 260px;
  min-width: 150px;
  float: left;
  margin-right: 3rem;
  border-radius: 50%;
  -webkit-shape-outside: circle();
  shape-outside: circle();
  border: 5px solid purple;
  box-shadow: 0 5px 20px #333;
}

/* Typography */
/**************************/
h3 {
  color: white;
  font-size: 24px;
  background-color: #2c4a66;
  padding: 5px;
}
h6 {
  color: white;
  font-size: 24px;
  background-color: #2c4a66;
  padding: 8px;
}

h4 {
  color: black;
  font-size: 28px;
}
em {
  color: white;
  font-size: 20px;
  padding: 5px;
  font-weight: 400;
}

.frame {
  text-align: center;
}

iframe {
  width: 200px;
  height: 200px;
}

#parallax-world-of-ugg h1 {
  font-size: 20px;
  font-weight: 400;
  color: black;
  padding: 0;
  margin: 0;
}

#parallax-world-of-ugg h2 {
  font-size: 70px;
  text-align: center;
  color: white;
  font-weight: 400;
  z-index: 10;
  opacity: 0.9;
}

#parallax-world-of-ugg h5 {
  font-size: 28px;
  color: black;
  background-color: purple;
  border-radius: 0 20px 0 20px;
  color: white;
  padding: 8px;
  margin: 0;
}

#parallax-world-of-ugg p {
  font-weight: 400;
  font-size: 18px;
  line-height: 20px;
}

#parallax-world-of-ugg li {
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  color: #333;
}

/* Section - Title */
/**************************/
#parallax-world-of-ugg .title {
  background: white;
  padding: 60px;
  margin: 0 auto;
  text-align: center;
}

/* Section - Block */
/**************************/
#parallax-world-of-ugg .block {
  padding: 30px;
  width: 80%;
  margin: 0 auto;
  text-align: left;
}

.section-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  justify-content: space-between;
  width: 80%;
  margin-left: 10%;
}

.section-image {
  width: 400px;
  height: auto;
  margin-right: 20px;
  flex-shrink: 0;
  border-radius: 25px;
  box-shadow: 0 5px 20px #333;
  transition: 0.3s ease-in-out;
}

.section-image:hover {
  transform: scale(1.1);
}

.img {
  text-align: center;
}

.img img {
  width: 400px;
}

.buttton {
  display: flex;
  justify-content: center;
}

.button {
  --width: 320px;
  --height: 80px;
  --tooltip-height: 35px;
  --tooltip-width: 90px;
  --gap-between-tooltip-to-button: 18px;
  --button-color: purple;
  --tooltip-color: #fff;
  width: var(--width);
  font-size: 30px;
  height: var(--height);
  background: var(--button-color);
  position: relative;
  text-align: center;
  border-radius: 0 40px 0 40px;
  box-shadow: 0 5px 30px purple;
  transition: background 0.3s;
  transition: 0.3s ease-in-out;
  cursor: pointer;
}
.button:hover {
  border-radius: 40px 0 40px 0;
  box-shadow: 0 5px 50px rgb(83, 1, 83);
}

.button::before {
  position: absolute;
  content: attr(data-tooltip);
  width: var(--tooltip-width);
  height: var(--tooltip-height);
  background-color: var(--tooltip-color);
  font-size: 0.9rem;
  color: #111;
  line-height: var(--tooltip-height);
  bottom: calc(var(--height) + var(--gap-between-tooltip-to-button) + 10px);
  left: calc(50% - var(--tooltip-width) / 2);
}

.button::after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-top-color: var(--tooltip-color);
  left: calc(50% - 10px);
  bottom: calc(100% + var(--gap-between-tooltip-to-button) - 10px);
}

.button::after,
.button::before {
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s;
}

.text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.button-wrapper,
.text,
.icon {
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  color: #fff;
}

.text {
  top: 0;
}

.text,
.icon {
  transition: top 0.5s;
}

.icon {
  color: #fff;
  top: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon svg {
  width: 50px;
  height: 50px;
}

.button:hover {
  background: rgb(65, 1, 65);
}

.button:hover .text {
  top: -100%;
}

.button:hover .icon {
  top: 0;
}

.button:hover:before,
.button:hover:after {
  opacity: 1;
  visibility: visible;
}

.button:hover:after {
  bottom: calc(var(--height) + var(--gap-between-tooltip-to-button) - 20px);
}

.button:hover:before {
  bottom: calc(var(--height) + var(--gap-between-tooltip-to-button));
}

/*--------- MODAL FOR BROCHURE ---------*/

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content h3 {
  color: #2c4a66;
  border-bottom: #000 solid 3px;
}

.modal-content a {
  color: #2c4a66;
  text-decoration: none;
  font-weight: 500;
  transition: 0.3s ease-in-out;
}
.modal-content a:hover {
  color: #000;
  font-weight: 500;
}

.modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: 20px;
  transform: translate(-50%, -50%);
  background-color: white;
  color: black;
  padding: 20px;
  border-radius: 10px;
  width: 900px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  text-align: left;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  height: auto;
  overflow: visible;
}

.close-button {
  margin-top: 20px;
  background-color: #2c4a66;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  transition: 0.3s ease-in-out;
}

.close-button:hover {
  background-color: #1f3550;
}

.scroll-container {
  overflow-y: auto;
  padding-right: 10px;
  position: relative;
  flex-grow: 1;
  scrollbar-width: thin;
  scrollbar-color: #2c4a66 #e0e0e0;
}

/* Custom scrollbar for WebKit browsers */
.scroll-container::-webkit-scrollbar {
  width: 8px;
}

.scroll-container::-webkit-scrollbar-track {
  background: #e0e0e0;
  border-radius: 10px;
}

.scroll-container::-webkit-scrollbar-thumb {
  background-color: #2c4a66;
  border-radius: 10px;
  border: 2px solid #e0e0e0;
}

/* Fading edges */
.scroll-container::before,
.scroll-container::after {
  content: "";
  position: sticky;
  left: 0;
  right: 0;
  height: 20px;
  pointer-events: none;
  z-index: 10;
}

.scroll-container::before {
  top: 0;
  background: linear-gradient(to bottom, white, transparent);
}

.scroll-container::after {
  bottom: 0;
  background: linear-gradient(to top, white, transparent);
}

/* Scroll progress bar */
.scroll-progress {
  position: absolute;
  top: 0;
  right: 0;
  width: 4px;
  background-color: #2c4a66;
  border-radius: 2px;
  transition: height 0.2s ease;
}

/* Media Queries */
/**************************/
@media screen and (max-width: 959px) and (min-width: 768px) {
  #parallax-world-of-ugg .block {
    padding: 40px;
    width: 620px;
  }
}
@media screen and (max-width: 767px) {
  #parallax-world-of-ugg .block {
    padding: 30px;
    width: 420px;
  }
  #parallax-world-of-ugg h2 {
    font-size: 30px;
  }
  #parallax-world-of-ugg .block {
    padding: 30px;
  }
  #parallax-world-of-ugg .parallax-one,
  #parallax-world-of-ugg .parallax-two,
  #parallax-world-of-ugg .parallax-three {
    padding-top: 100px;
    padding-bottom: 100px;
  }
  #circle-shape-example .curve {
    width: 120px;
    height: 140px;
  }
}
@media screen and (max-width: 479px) {
  #parallax-world-of-ugg .block {
    padding: 30px 15px;
    width: 290px;
  }
  #circle-shape-example .curve {
    width: 100px;
    height: 120px;
  }
  .section-flex {
    display: flex;
    flex-wrap: wrap;
  }
  .section-image {
    width: 200px;
  }
  #parallax-world-of-ugg li {
    font-size: 15px;
    line-height: 20px;
  }
  .start-info {
    font-size: 18px;
    text-align: left;
  }
  .modal-content {
    width: 350px;
    height: 430px;
    margin-top: 40px;
  }
  .img img {
    width: 100%;
  }
}
</style>
